<template>
	<transition enter-active-class="animated fadeIn faster"
	            leave-active-class="animated fadeOut faster"
	            :key="'remove'">
		<div class="container-fluid flex-column position-absolute justify-content-center h-100 main"
		     id="remove"
		     v-show="operatorDelete.show">
			<div class="container bg-light col-lg-8 col-md-8 col-xl-7 col-sm-8 p-5 popup">
				<div class="flex-column justify-content-center">
					<div class="title cont">вы действительно хотите удалить оператор {{ operatorDelete.name }}?</div>
					<div class="container justify-content-around cont mt-3">
						<button class="btn btn-outline-danger button" @click="deleteOper">удалить</button>
						<button class="btn btn-outline-dark button" @click="cancel">отменить</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
	import { performRequest } from "../script/ws/wsclient";
	import { mapGetters }     from "vuex";

	export default {
		name:     "DeleteOperator",
		data() {
			return {};
		},
		props:    {
			operatorDelete: Object
		},
		computed: {
			...mapGetters(["getViewUser"])
		},
		methods:  {
			deleteOper() {
				performRequest(
					{
						section: "tvcontent.operator",
						name:    "deleteOperator"
					},
					{
						name:     this.operatorDelete.name,
						operator: this.getViewUser
					},
					a => {
						if (a.code === 200) {
							this.$emit("hiddenDeleteOper", { show: false, getOper: true });
						}
						else if (a.code === 400) {
							this.errorHandler("введены не корректные данные");
						}
						else if (a.code === 500) {
							this.errorHandler("ошибка на сервере");
						} else if (a.code === 409) {
							this.$emit('hasDepend');
						}
						else {
							console.log("ошибка =(((");
						}
					});
			},
			cancel() {
				this.$emit("hiddenDeleteOper", { show: false, getOper: false });
			}
		}
	};
</script>
<style scoped lang="scss">
	@import "~bootstrap/scss/bootstrap";
	.btn {
		padding: 0 1rem;
		height: 3rem;
		min-width: 5rem;
		margin: 0;
	}
	.list {
		border-top: 1px solid rgba(44, 62, 80, 0.47);
		transition: background-color .3s;
		&:hover {
			background-color: rgba(128, 140, 166, 0.33);
		}
		&:last-child {
			border-bottom: 1px solid rgba(44, 62, 80, 0.47);
		}
		
	}
	.label {
		width: 200px;
	}
	.main {
		background-color: rgba(130, 130, 130, 0.27);
		flex-direction: column;
	}
	.input {
		width: 70%;
		height: 1.8rem;
		outline: none;
		border: 1px solid gray;
		border-radius: 3px;
		transition: all .3s;
		padding-left: 5px;
		&:focus {
			border: 1px solid #acafff;
			box-shadow: 0 0 7px #acafff;
		}
	}
	.popup {
		top: 50%;
		transform: translateY(-50%);
	}
	.err_handler {
		bottom: 1.5rem;
		font-size: 1.1rem;
		left: 3.8rem;
	}
	.cont {
		text-align: center;
	}
	.button {
		max-height: 2rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/DeleteOperator.vue